export const GET_APPLIED_FILTERS = "/api/v1/clinic/get-user-settings";
export const ADD_UPDATE_APPLIED_FILTERS = "/api/v1/clinic/user_settings";
export const GET_CLINIC_DOCS = "clinic/get-clinic-doctors";
export const GET_DOCTOR_ACCOUNTS = "/api/v1/doctor/accounts";
export const GET_DOCTOR_ACCOUNTS_APPOINTMENT ="api/v1/doctor-appointment-day-count";
